import { forwardRef } from 'react';

import { PUBLIC_CORE_APP_URL_ENV } from 'tools/environments';

import { MobileAppInstallBanner } from '../../general/mobile-app-install-banner';
import { BasketIcon, MyAccountButton, Nav, SearchIcon } from './components';
import { SmartLink } from './components/smart-link';
import styles from './header-navigation.module.scss';
import { TopBanner, TopBannerSlotId } from './top-banner';
import { NavItemType } from './types';

export type HeaderNavigationData = NavItemType[];

export type HeaderNavigationProps = {
	menuItems: HeaderNavigationData;
	stickyHeader?: boolean;
	showBasketIcon?: string;
	topBannerSlotId?: TopBannerSlotId | null;
};

export const HeaderNavigation = forwardRef<
	HTMLDivElement,
	HeaderNavigationProps
>(
	(
		{ menuItems, stickyHeader = true, showBasketIcon, topBannerSlotId },
		ref
	) => {
		return (
			<div
				className={`${styles['header-navigation']} ${
					stickyHeader ? styles.isSticky : styles.isNotSticky
				}`}
				ref={ref}
			>
				<TopBanner slotId={topBannerSlotId} />
				<MobileAppInstallBanner showOnPaths={['/']} />
				<div className={`container ${styles['container']}`}>
					<SmartLink
						href="/"
						className={`${styles.crest} ${
							!stickyHeader ? styles.crestNonSticky : ''
						}`}
						aria-label="Manchester City FC"
					>
						<img
							src={`${PUBLIC_CORE_APP_URL_ENV}/assets/images/crest/ManCity-Coloured.svg`}
							alt="Manchester City FC"
							width="67"
							height="67"
						/>
					</SmartLink>

					<div className={`${styles.nav}`}>
						{menuItems.length > 0 && <Nav items={menuItems} />}
					</div>

					<div className={styles.search}>
						<SearchIcon />
					</div>

					<div className={styles.button}>
						<MyAccountButton />
					</div>

					{showBasketIcon === 'true' && (
						<div className={styles.basket}>
							<BasketIcon />
						</div>
					)}

					<a
						className={`${styles.wix}`}
						target="_blank"
						href="http://pubads.g.doubleclick.net/gampad/clk?id=5447931055&amp;iu=/53973057/homepage"
						aria-label="Wix"
						rel="noreferrer"
					>
						<img
							src={`${PUBLIC_CORE_APP_URL_ENV}/assets/images/logos/wix_homepage_v2.png`}
							alt="Wix"
							loading="lazy"
							width="49"
							height="24"
						/>
					</a>
				</div>
			</div>
		);
	}
);

HeaderNavigation.displayName = 'HeaderNavigation';

export default HeaderNavigation;
